'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const ZINNIA_RESET_STYLESHEET_URL = `https://design-system-css.zapier.com/reset.css`;
const ZinniaStylesReset = (props) => {
  return React__default.default.createElement("link", Object.assign({ href: ZINNIA_RESET_STYLESHEET_URL, rel: "stylesheet" }, props));
};

exports.ZINNIA_RESET_STYLESHEET_URL = ZINNIA_RESET_STYLESHEET_URL;
exports.ZinniaStylesReset = ZinniaStylesReset;
//# sourceMappingURL=ZinniaStylesReset.cjs.js.map
